export default __webpack_public_path__ + "static/media/map.cb52b970.svg";